(function(){
if(window.__wvbInit){return}
window.__wvbInit=1;
document.addEventListener('click',function(e){
 var b=e.target.closest('.wvb-rm');
 if(!b){return}
 e.preventDefault();
 if(b.disabled){return}
 var keys=(b.getAttribute('data-wvb-keys')||'').split(',').filter(Boolean);
 if(!keys.length){return}
 b.disabled=true;
 b.textContent='Removing...';
 var d=b.closest('cart-drawer');
 fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
  var body={updates:c.items.map(function(it){return keys.indexOf(it.key)>-1?0:it.quantity})};
  if(d&&d.getSectionsToRender){body.sections=d.getSectionsToRender().map(function(s){return s.id}).join(',');body.sections_url=window.location.pathname}
  return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
 }).then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})}).then(function(res){
  if(!res.ok){throw new Error('update failed')}
  if(d&&d.renderContents&&res.j.sections){d.classList.toggle('is-empty',res.j.item_count===0);d.renderContents(res.j);if(window.freeShippMsg){window.freeShippMsg()}}
  else{window.location.reload()}
 }).catch(function(){b.disabled=false;b.textContent='Remove bundle'});
});
})();
